bam-stage-large {
  &:not(.is-slide) {
    // margin-bottom: 3rem; Shape only

    margin-bottom: 3rem;

    @include tablet {
      margin-bottom: 5rem;
    }
  
    @include desktop {
      margin-bottom: 5rem;
    }
  }

  &.is-video:not(.has-interferer) {
    margin-bottom: 4rem;

    @include tablet {
      margin-bottom: 128px;
    }
  }
  
  &.has-interferer {
    margin-bottom: 0 
  }

  bal-stage {
    position: relative !important;

    section {
      overflow: hidden;
      height: 0;
      padding-top: 56.25%;

      @include desktop {
        overflow: unset;
        height: auto;
        padding-top: 0
      }
    }
  }

  .bam-stage-large__video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  bal-stage-body {
    min-height: 200px;

    @include tablet {
      min-height: 432px
    }

    bal-text{
      max-width: 520px
    }
  }

  .stage-large__btn-wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    bal-button {
      flex: 0 1 100%;

      & > * {
        width: 100%;
      }

      @include tablet {
        flex: 0 1 auto;

        &[color="link"] {
          a {
            padding-left: 0;
            border-left: 0
          }
        }

        &[color="primary"] {
          margin-right: 1.5rem;
        }
      }
    }
  }

  .bam-stage-large__headline-mobile {
    padding: 0 1rem;
    
    @include tablet {
      padding: 0 40px;
    }
  }

  .bam-stage-large__card-mobile {
    padding: 0 1rem;
    margin-top: -2rem;
    margin-bottom: 1rem;

    @include tablet {
      padding: 0 40px;
      margin-bottom: 1.5rem;
    }

    @include desktop {
      margin: unset;
      padding: unset;
    }

    bal-card {
      position: relative;

      .bal-card-content {
        padding: 20px 20px !important;

        & > bal-heading {
          max-width: calc(100% - 72px);

          @include tablet {
            max-width: calc(100% - 136px)
          }
        }

        & > bal-heading,
        & > bal-text {
          @include tablet {
            width: calc(100% - 136px)
          }
        }
      }

      bal-shape {
        position: absolute;
        top: -44px;
        right: 1.5rem;

        @include tablet {
          top: -80px;
        }
      }
    }
  }
}
